export const COLONY_USERNAME_MIN = 3
export const COLONY_USERNAME_MAX = 20
export const COLONY_USERNAME_HINT = '3–20 letters, numbers, or underscores. Usernames are unique and shown instead of your wallet.'

const USERNAME_RE = /^[A-Za-z][A-Za-z0-9_]{2,19}$/
const RESERVED = new Set([
  'admin',
  'colony',
  'explore',
  'moderator',
  'official',
  'penguin',
  'penguinpad',
  'pengu',
  'support',
])

export function normalizeUsernameKey(value?: string) {
  return value?.trim().toLowerCase() || ''
}

export function sanitizeColonyUsername(value?: string) {
  const trimmed = value?.trim() || ''
  if (!trimmed)
    return ''
  if (!USERNAME_RE.test(trimmed))
    throw new Error('Usernames must be 3–20 characters, start with a letter, and use only letters, numbers, or underscores')
  if (RESERVED.has(normalizeUsernameKey(trimmed)))
    throw new Error('That username is reserved')
  return trimmed
}

export function displayColonyUsername(username?: string, fallback = 'Colony member') {
  const trimmed = username?.trim() || ''
  return trimmed || fallback
}
